import { render } from "./SmoothHeight.vue?vue&type=template&id=05f2074c"
import script from "./SmoothHeight.vue?vue&type=script&lang=js"
export * from "./SmoothHeight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__